import { createContext } from "react";

import { ListNode } from "components/objectTree/types";
import { ModelTreeNodeData } from "features/modelTree/types";

/** First click of a possible double-click. Kept on the window so a row remount cannot drop it. */
export type RowClickGesture = {
    path: string;
    time: number;
    /** The gesture already toggled expand, so a following dblclick must not toggle again. */
    expanded: boolean;
    /** This press already selected the row on mouse-down. The click must not select again. */
    suppressClick?: boolean;
    /**
     * Armed when a plain click lands on an already selected row. Its result (deselect a sole
     * row, or collapse a multi-selection to this row) waits so a double-click can cancel it.
     */
    pendingTimer?: number;
    /** The selection when `pendingTimer` was armed. A different selection cancels the wait. */
    armedPaths?: Set<string>;
};

export function sameRowSelection(a: Set<string>, b: Set<string>): boolean {
    if (a === b) {
        return true;
    }
    if (a.size !== b.size) {
        return false;
    }
    for (const path of a) {
        if (!b.has(path)) {
            return false;
        }
    }
    return true;
}

export type V2SelectionContext = {
    selectedRowPaths: Set<string>;
    /** Latest selection, so a deferred deselect can see a clear that happened after the click. */
    selectedRowPathsRef?: React.MutableRefObject<Set<string>>;
    list: ListNode<ModelTreeNodeData>[];
    onRowSelect: (path: string, event: React.MouseEvent) => void;
    onToggleVisibilityForSelection?: (isHidden: boolean) => void;
    rowClickGestureRef?: React.MutableRefObject<RowClickGesture | null>;
};

export const SelectionContext = createContext<V2SelectionContext | null>(null);
